import { BJumbotron } from './jumbotron'
import { pluginFactory } from '../../utils/plugins'

const JumbotronPlugin = /*#__PURE__*/ pluginFactory({
  components: { BJumbotron }
})

export { JumbotronPlugin, BJumbotron }
